<template>
    <popup-wrapper
        class="popup-power-info"
        v-if="popShow"
        @pop-cls="handlePopCls"
        :hasCls="false"
    >
        <h3>
            <span>{{ $t('popup.powerInfo.title') }}</span>
        </h3>
        <div class="content" v-html="$t('popup.powerInfo.content')"></div>
        <div class="btn-cls" @click="handlePopCls">
            {{ $t('base.close_btn') }}
        </div>
    </popup-wrapper>
</template>

<script>
import popupWrapper from '@/components/popup/popup-wrapper';
export default {
    name: 'popup-power-info',
    components: {
        popupWrapper
    },
    computed: {
        popShow() {
            return this.$store.state.popup.powerInfo;
        }
    },
    methods: {
        handlePopCls() {
            this.$store.commit('HIDE_POPUP', 'powerInfo');
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 14px 40px 12px 36px;

    .content {
        width: 100%;
        height: 510px;
        padding-right: 10px;
        box-sizing: border-box;
        overflow: auto;
    }

    h3 {
        text-align: center;
        margin-bottom: 16px;
        span {
            font-size: 36px;
            text-align: center;
            color: #9c9273;
            position: relative;
            &::before {
                content: '';
                width: 39px;
                height: 11px;
                position: absolute;
                right: -60px;
                top: 50%;
                margin-top: -8px;
                background: url(~@/assets/img/pop_title_l.png) center/100% 100%
                    no-repeat;
            }
            &::after {
                content: '';
                width: 39px;
                height: 11px;
                position: absolute;
                left: -60px;
                top: 50%;
                margin-top: -8px;
                background: url(~@/assets/img/pop_title_r.png) center/100% 100%
                    no-repeat;
            }
        }
    }

    .rule-item {
        margin-bottom: 10px;
    }

    h4 {
        font-size: 24px;
        // text-align: center;
        line-height: 2;
        color: #474747;
    }

    p {
        font-size: 24px;
        // text-align: center;
        line-height: 1.8;
        color: #474747;
    }

    .btn-cls {
        width: 189px;
        height: 74px;
        background: url(~@/assets/img/btn_blue_square.png) center/100% 100%
            no-repeat;
        margin: 20px auto 0;
        line-height: 74px;
        font-size: 36px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
}
</style>
